import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { DecorativeDivider } from './ui/DecorativeDivider';
export function ProblemExplanation() {
  return <section className="py-10 md:py-16 px-4 md:px-6 bg-navy-light" data-id="element-219">
      <div className="max-w-3xl mx-auto" data-id="element-220">
        <FadeIn data-id="element-221">
          <h2 className="text-2xl md:text-4xl font-serif text-center mb-6 md:mb-10 text-white text-balance" data-id="element-222">
            Lo que está pasando <br className="hidden md:block" data-id="element-223" />
            <span className="italic text-gold text-xl md:text-3xl" data-id="element-224">
              (y por qué te sientes atrapada)
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-4 md:space-y-6 text-base md:text-xl text-white/70 leading-relaxed" data-id="element-225">
          <FadeIn delay={0.1} data-id="element-226">
            <p data-id="element-227">Los bebés se despiertan entre ciclos (eso es normal).</p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-228">
            <p data-id="element-229">
              El problema aparece cuando, al despertar, tu bebé necesita
              exactamente lo mismo que tuvo para dormirse al inicio: pecho,
              brazos, movimiento, chupete, presencia…
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-230">
            <p className="font-medium text-white" data-id="element-231">
              Entonces cada despertar se convierte en "volver a empezar".
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-232">
            <p data-id="element-233">
              Y tú terminas haciendo el trabajo de reiniciar el sueño una y otra
              vez.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-234">
            <p className="mt-5 md:mt-8 p-4 md:p-6 bg-gold/10 rounded-xl md:rounded-2xl border border-gold/20 text-center font-medium text-gold text-sm md:text-base" data-id="element-235">
              Esta guía te ayuda a cambiar eso con dirección y pasos claros.
            </p>
          </FadeIn>
        </div>

        <DecorativeDivider data-id="element-236" />
      </div>
    </section>;
}